import { toast } from 'react-toastify';
import { getValueByPath } from './parse';


export const getErrorObject = (error: any) => {
  return error?.response?.data?.error
}


export const useError = (apiError: any) => {
  const error = getErrorObject(apiError)

  function getError(field: string = "nonFieldErrors", all: boolean = false) {
    const fieldErrors = getValueByPath(field, error?.errorList)

    if (all)
      return fieldErrors
    return fieldErrors?.[0] || ""
  }

  return {
    getError
  }
}

export const handleErrorMessage = (error: any) => {
  // const _error = error?.response?.data?.error;
  const _error = getErrorObject(error)

  const singleError = _error?.detail;
  const multipleErrors = _error?.errorList;

  /* Commented the code bellow to decrease the complexity and
  improve readability by letting this only for generic unhandled errors */

  // const zipCodeError = multipleErrors?.address?.postalCode?.[0];

  // const emailError =
  //   singleError === 'The email provided is already in use' ||
  //   singleError === 'The contract has not been finished yet. Click here to receive an email to continue your contract.' ||
  //   "email" in multipleErrors;


  // const errorCustomMessage = {
  //   zipCodeError,
  //   emailError,
  // };

  // if (emailError || zipCodeError) {
  //   return errorCustomMessage;
  // } else {
  if (_error) {
    if (!multipleErrors) {
      toast.error(singleError, {
        autoClose: false,
      });
    } else {
      toast.error(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Validation failed: ${Object.values(multipleErrors)}`,
        {
          autoClose: false,
        }
      );
    }
  } else {
    toast.error('Unexpected error. Please, try again.', {
      autoClose: false,
    });
  }
  // }
};
